import { User, UserAction, UserActions } from "../model";
import createReducer from "./createReducer";

export const user = createReducer<User>(null, {
	[UserActions.SET_USER](state: User, action: UserAction) {
		return action.payload;
	},
});
